import React, { useState } from 'react';
import { FaUser, FaCog, FaUniversity, FaFileAlt, FaSignOutAlt, FaBuilding } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';

const Sidebar = () => {
  const [activeItem, setActiveItem] = useState('Clients');
  const navigate = useNavigate();

  const menuItems = [
    { name: 'Tiers', path: '/clients', icon: <FaUser /> },

    { name: 'Banque', path: '/banque', icon: <FaUniversity /> },
    { name: 'Cheque', path: '/cheque', icon: <FaFileAlt /> },
    { name: 'Logout', path: '/logout', icon: <FaSignOutAlt /> },
  ];

  const handleLogout = () => {
    localStorage.removeItem('user');
    navigate('/login');
  };

  return (
    <div className="sidebar">
      <div className="logo-container">
        <img src="/logo.png" alt="Logo" className="sidebar-logo" />
      </div>
      <ul className="menu-items">
        {menuItems.map((item) => (
          <li
            key={item.name}
            className={`${activeItem === item.name ? 'active' : ''} ${item.name === 'Logout' ? 'logout-item' : ''}`}
          >
            {item.name === 'Logout' ? (
              <button onClick={handleLogout} className="logout-button">
                <span className="icon">{item.icon}</span>
                <span className="text">{item.name}</span>
              </button>
            ) : (
              <Link to={item.path} onClick={() => setActiveItem(item.name)}>
                <span className="icon">{item.icon}</span>
                <span className="text">{item.name}</span>
              </Link>
            )}
          </li>
        ))}
      </ul>

      <style jsx>{`
        .sidebar {
          background: linear-gradient(135deg, #2c3e50 0%, #3498db 100%);
          color: white;
          height: 100vh;
          width: 200px;
          position: fixed;
          top: 0;
          left: 0;
          padding: 20px 0;
          z-index: 1000;
          display: flex;
          flex-direction: column;
          border-radius: 0 10px 10px 0;
          box-shadow: 2px 0 15px rgba(0, 0, 0, 0.1);
          transition: all 0.3s ease;
        }

        .logo-container {
          display: flex;
          justify-content: center;
          margin-bottom: 30px;
          padding: 0 20px;
        }

        .sidebar-logo {
          width: 120px;
          height: auto;
          border-radius: 8px;
        }

        .menu-items {
          list-style: none;
          padding: 0 15px;
          margin: 0;
          flex-grow: 1;
          display: flex;
          flex-direction: column;
        }

        .menu-items li {
          margin-bottom: 10px;
          transition: all 0.3s ease;
        }

        .menu-items li a,
        .logout-button {
          display: flex;
          align-items: center;
          text-decoration: none;
          color: white;
          padding: 12px 15px;
          border-radius: 8px;
          font-size: 1rem;
          font-weight: 500;
          transition: all 0.3s ease;
        }

        .logout-button {
          background: none;
          border: none;
          width: 100%;
          text-align: left;
          cursor: pointer;
        }

        .logout-button:hover,
        .menu-items li a:hover {
          background-color: rgba(255, 255, 255, 0.1);
          font-size: 1.1rem;
          transform: scale(1.05);
        }

        .menu-items li.active a {
          background: rgba(255, 255, 255, 0.2);
          border-left: 4px solid #3498db;
          font-size: 1.1rem;
        }

        .icon {
          margin-right: 12px;
          font-size: 1.2rem;
          width: 24px;
          display: flex;
          justify-content: center;
        }

        .logout-item {
          margin-top: auto;
          margin-bottom: 20px;
        }

        .logout-item a {
          background: rgba(231, 76, 60, 0.2);
        }

        .logout-item:hover a {
          background: rgba(231, 76, 60, 0.4) !important;
        }

        @media (max-width: 768px) {
          .sidebar {
            width: 80px;
          }

          .text {
            display: none;
          }

          .logo-container {
            padding: 0 10px;
          }

          .sidebar-logo {
            width: 60px;
          }

          .menu-items li a {
            justify-content: center;
            padding: 12px 0;
          }

          .icon {
            margin-right: 0;
            font-size: 1.4rem;
          }
        }

        @media print {
          .sidebar {
            display: none;
          }
        }
      `}</style>
    </div>
  );
};

export default Sidebar;
